import { render, staticRenderFns } from "./TarjetaDireccion.vue?vue&type=template&id=747f3ad5&"
import script from "./TarjetaDireccion.vue?vue&type=script&lang=js&"
export * from "./TarjetaDireccion.vue?vue&type=script&lang=js&"
import style0 from "./TarjetaDireccion.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports